import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_PAYMENT_DATA_BY_TOKEN } from '../operations/queries/get-payment-by-token.js';

const useGetPaymentDataByToken = ({ onError , onCompleted ,  } = {})=>{
    const [getPaymentData, { loading , data , error: error1  }] = useLazyQuery(GET_PAYMENT_DATA_BY_TOKEN, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            onError && onError({
                reason: 'QUERY',
                error
            });
        },
        onCompleted () {
            onCompleted && onCompleted('getPaymentByToken');
        }
    });
    const getPaymentDataByToken = React.useCallback((token)=>{
        if (!token.length) {
            console.error('Payment token cannot be empty');
            return;
        }
        if (token) {
            getPaymentData({
                variables: {
                    input: {
                        token
                    }
                }
            });
        }
    }, [
        getPaymentData
    ]);
    const queryResults = React.useMemo(()=>{
        return {
            data: data === null || data === void 0 ? void 0 : data.getPaymentByToken,
            isPaymentDataLoading: loading,
            error: error1
        };
    }, [
        data === null || data === void 0 ? void 0 : data.getPaymentByToken,
        error1,
        loading
    ]);
    return swcHelpers.objectSpread({}, queryResults, {
        getPaymentDataByToken
    });
};

export { useGetPaymentDataByToken };
//# sourceMappingURL=use-get-payment-by-token.js.map
